import { render, staticRenderFns } from "./AccountStatisticCUA.vue?vue&type=template&id=356274a8"
import script from "./AccountStatisticCUA.vue?vue&type=script&lang=js"
export * from "./AccountStatisticCUA.vue?vue&type=script&lang=js"
import style0 from "./AccountStatisticCUA.vue?vue&type=style&index=0&id=356274a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports